module.exports = __webpack_public_path__ + "img/signup.578332ac.svg";